var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17104_37335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 3.33366C0.667969 2.96547 0.966449 2.66699 1.33464 2.66699H14.668C15.0362 2.66699 15.3346 2.96547 15.3346 3.33366V12.667C15.3346 13.0352 15.0362 13.3337 14.668 13.3337H1.33464C0.966449 13.3337 0.667969 13.0352 0.667969 12.667V3.33366ZM8.66797 5.33366V6.66699H12.668V5.33366H8.66797ZM12.0013 8.00033H8.66797V9.33366H12.0013V8.00033ZM7.0013 6.66699C7.0013 5.74652 6.25511 5.00033 5.33464 5.00033C4.41416 5.00033 3.66797 5.74652 3.66797 6.66699C3.66797 7.58746 4.41416 8.33366 5.33464 8.33366C6.25511 8.33366 7.0013 7.58746 7.0013 6.66699ZM5.33464 9.00033C4.04597 9.00033 3.0013 10.045 3.0013 11.3337H7.66797C7.66797 10.045 6.6233 9.00033 5.33464 9.00033Z",
    fill: "#8CA2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17104_37335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorker);
export default __webpack_public_path__ + "static/media/icon_worker.c3eb9c55dade9cfdadae811dee09573f.svg";
export { ForwardRef as ReactComponent };